module.exports = __webpack_public_path__ + "img/tank-truck.e4e8b47.png";